module.exports = __webpack_public_path__ + "static/media/refresh.fc32a71b.svg";